import { setRedirectObject, setTwoFaReturnLoginUrl, setTwoFaTempUser } from '../store';
export var handleTwoFaLoginRedirect = function (payload) {
    var expiresAtDate = payload.expiresAt ? new Date(payload.expiresAt * 1000) : null;
    payload.dispatch(setTwoFaTempUser({
        user: payload.user,
        token: payload.token,
        expiresAt: expiresAtDate,
    }));
    payload.dispatch(setRedirectObject(payload.redirectObject));
    payload.dispatch(setTwoFaReturnLoginUrl(payload.loginUrl || '/login'));
    payload.navigate('/two-fa');
};
